import { render } from "./AvatarUploader.vue?vue&type=template&id=26462aa4&scoped=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"

import "./AvatarUploader.vue?vue&type=style&index=0&id=26462aa4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26462aa4"]])

export default __exports__